import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { IPrimaryFields } from '../../../Models/FormFlowViewModel/IPrimaryFields';
import { ModuleService } from '../../../Services/module.service';
import { FormFlowFieldTypes } from '../../../../../../Constants/FormFlowFieldTypes';
import { Field, FieldGroup, Step } from '../../../Models';

@Injectable({
    providedIn: 'root'
})
export class FieldService {
    private editCustomField$: Subject<any> = new Subject();
    private deletedCustomField$: Subject<any> = new Subject();
    private drivingFields$: Subject<Field[]> = new BehaviorSubject(null);
    private primaryFields$: Subject<IPrimaryFields[]> = new BehaviorSubject(null);

    constructor(private moduleService: ModuleService) {
        this.moduleService.getCurrentStepFields().subscribe((fields) => {
            if (fields !== null) {
                const drivingFields = fields.filter((f: Field) =>
                    f.ListParams &&
                    f.ListParams["ListType"] === "AIRSWEBLIST" &&
                    f.ListParams["ListAlias"]
                );
                this.drivingFields$.next(drivingFields);

                const primaryFields = fields
                    .filter((f: Field) => f.HasPrimaryField && f.PrimaryFields)
                    .map((f: Field) => f.PrimaryFields);
                this.primaryFields$.next(primaryFields);
            }
        });
    }

    startEditingCustomField(fieldGroup: FieldGroup, field: Field) {
        this.editCustomField$.next({ fieldGroup: fieldGroup, field: field });
    }

    getEditCustomField(): Observable<{ fieldGroup: FieldGroup, field: Field }> {
        return this.editCustomField$.asObservable();
    }

    startAddingCustomField(fieldGroup: FieldGroup) {
        return this.editCustomField$.next({ fieldGroup: fieldGroup, field: null });
    }

    public getDeleteCustomField(): Observable<Field> {
        return this.deletedCustomField$;
    }

    public deleteCustomField(field: Field): void {
        this.deletedCustomField$.next(field);
    }

    getDrivingFields(): Observable<Field[]> {
        return this.drivingFields$.asObservable();
    }

    getPrimaryFields(): Observable<IPrimaryFields[]> {
        return this.primaryFields$.asObservable();
    }

    getFieldsFromSteps(availableSteps: Step[]): Field[] {
        let availableFields = [];

        if (availableSteps && availableSteps.length > 0) {

            availableFields =
                availableSteps
                    .map(s => s.Fields
                        .filter(field => field.FieldUniqueId !== FormFlowFieldTypes.MultiItem))
                    .reduce((currentArray, completeArray) => [...currentArray, ...completeArray]);

            for (const step of availableSteps) {
                const multiItems = step.Fields.filter(field => field.FieldUniqueId === FormFlowFieldTypes.MultiItem);

                if (multiItems.length > 0) {
                    availableFields = availableFields.concat(
                        multiItems.map(mi => mi.MultiFields)
                            .reduce((currentArray, completeArray) => [...currentArray, ...completeArray]));
                }
            }
        }

        return availableFields;
    }
}
